import React, { useEffect, useState } from "react";
import "./setting.css";
import Users from "./Users";
import Roles from "./Roles";

const Setting = () => {
  const [activeTab, setActiveTab] = useState("Users");

  return (
    <div className="container mt-4 trip-container">
      <div className="report-results mt-4">
        <div className="tabs-container">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div className="tabs">
              {["Users", "Roles"].map((tab) => (
                <p
                  key={tab}
                  className={`mb-0 tab-item ${
                    activeTab === tab ? "active1" : ""
                  }`}
                  onClick={() => setActiveTab(tab)}
                  style={{ fontSize: "18px", fontWeight: "600" }}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </p>
              ))}
            </div>
          </div>
          <hr className="divider" />
        </div>
        {activeTab === "Users" ? <Users /> : <Roles />}
      </div>
    </div>
  );
};

export default Setting;
